import { gql } from "@apollo/client";

export const BANNER_FIELDS = gql`
  fragment BannerFields on Banner {
    id
    type
    name
    source
    timeStatus
    isActive
    startTime
    endTime
    imageURL
    squareImageURL
    sellerSegmentType
    applicableProductIDs
    applicableProducts {
      id
      name
      code
      __typename
    }
    navigation {
      type
      targetID
      url
      targetName
      isTargetActive
      __typename
    }
    screens {
      screen
      queuePosition
      isActive
      __typename
    }
    promotionCampaignID
    promotionCampaign {
      id
      name
      __typename
    }
    campaignID
    campaign {
      id
      name
      type
      __typename
    }
    popup {
      triggerType
      triggerDelayValue
      triggerDelayUnit
      displayDurationSeconds
      maxImpressions
      stopAfterClicks
      frequencyCount
      frequencyPeriodValue
      frequencyPeriod
      __typename
    }
    announcementBar {
      position
      allowClose
      displayType
      message
      ctaText
      iconMode
      iconPresetCode
      iconURL
      backgroundMode
      colorPresetCode
      backgroundColor
      gradientFromColor
      gradientToColor
      gradientAngle
      textColor
      iconColor
      buttonColor
      buttonTextColor
      __typename
    }
    createdByID
    createdBy {
      id
      fullname
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
`;

export const SEARCH_BANNERS = gql`
  query SearchBanners($filters: SearchBannersFilters, $pagination: PaginationRequest) {
    banner {
      searchBanners(filters: $filters, pagination: $pagination) {
        banners {
          ...BannerFields
        }
        paginationData {
          total
          offset
          limit
          cursorHasNext
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;

export const GET_BANNER_DETAIL = gql`
  query GetBannerDetail($id: ID!) {
    banner {
      getBannerDetail(id: $id) {
        ...BannerFields
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;

export const GET_BANNER_QUEUE = gql`
  query GetBannerQueue($input: BannerQueueKeyInput!) {
    banner {
      getBannerQueue(input: $input) {
        banner {
          ...BannerFields
        }
        queuePosition
        isActive
        __typename
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;

export const LIST_SELLER_SCREEN_BANNERS = gql`
  query SellerScreenBanners($input: SellerScreenBannersInput, $pagination: PaginationRequest) {
    sellerQuery {
      banner {
        listByScreen(input: $input, pagination: $pagination) {
          banners {
            ...BannerFields
          }
          paginationData {
            total
            offset
            limit
            cursorHasNext
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${BANNER_FIELDS}
`;
